import { ReactElement } from 'react'
import { ThemeProvider } from 'styled-components'
import { Outlet } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { ErrorBoundary } from 'react-error-boundary'
import GlobalStyle from '~assets/styles/global'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import i18nSetup from '../i18n'
import { DrawerCheckout } from '~containers'

type Product = {
  name: string
  description: string
  price: number
}

type DrawerCheckoutProps = {
  product: Product
  isOpen?: boolean
  isLoading?: boolean
  isError?: boolean
  isSuccess?: boolean
  isAllowed?: boolean
  onClose?: () => void
  onConfirm?: () => void
  onSuccess?: () => void
  onFail?: () => void
  onRetry?: () => void
  handleFormModal?: () => void
}

const DrawerCheckoutExtraProducts = (props: DrawerCheckoutProps): ReactElement => {
  const fallbackRender = (): JSX.Element => null

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary fallbackRender={fallbackRender}>
        <GlobalStyle />
        <Outlet />
        <I18nextProvider i18n={i18nSetup}>
          <DrawerCheckout {...props} />
        </I18nextProvider>
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default DrawerCheckoutExtraProducts
